import { useSelector } from 'react-redux';
import { HookTemplate } from '@rossum/api-client/hookTemplates';
import { useExtensionsFeatureSubscription } from '../../../../pricing/hooks/useExtensionsFeatureSubscription';
import {
  duplicateHandlingFeatureSelector,
  mailboxFeatureSelector,
} from '../../../../pricing/selectors';

export const DUPLICATE_HANDLING_NAME = 'Duplicate Handling';
export const mailboxExtensions = [
  'Advanced Email Filtering',
  'Email Notifications',
];

export const useIsHookTemplateRestricted = (
  hookTemplate: HookTemplate | null
) => {
  const extensionsSubscription = useExtensionsFeatureSubscription();
  const isDuplicateFeaturePurchased = useSelector(
    duplicateHandlingFeatureSelector
  );
  const isMailboxFeaturePurchased = useSelector(mailboxFeatureSelector);

  const restrictDuplicateHandling =
    hookTemplate &&
    !isDuplicateFeaturePurchased &&
    hookTemplate.name === DUPLICATE_HANDLING_NAME;

  const restrictMailboxExtensions =
    hookTemplate &&
    !isMailboxFeaturePurchased &&
    mailboxExtensions.includes(hookTemplate.name);

  return (
    !extensionsSubscription.purchased ||
    restrictDuplicateHandling ||
    restrictMailboxExtensions
  );
};
